import { render, staticRenderFns } from "./AppointmentsCompletedGenderChart.vue?vue&type=template&id=212d1588&"
import script from "./AppointmentsCompletedGenderChart.vue?vue&type=script&lang=js&"
export * from "./AppointmentsCompletedGenderChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports